export const getLocaleMessages = (locale: string) =>
  import(/* webpackChunkName: "[request]" */ `../i18n/translations/${locale}.json`).then((module) => module.default);

export const formatLocale = (locale?: string): string | undefined => {
  return locale?.replace('_', '-');
};
